module.exports = __webpack_public_path__ + "static/media/2004 Ho Chi Minh City, Vietnam.dc1b02cc.jpg";